 <!--快速点击类组件-->
<template>
    <div class="quickRepliesWrapper">
        <div class="scrollView scrollView--fullWidth scrollView--x quickReplies"
             :style="{'display':!show?'block':'none'}">
            <div class="scrollView-scroller-min">
                <div class="scrollView-inner">
                    <RButton v-for="(item,ix) in list" :key="`tips-quick-${ix}`"   :color="color" @on-click="()=>onAsk(item.name,item.value,item.id)" :font-color="item.fontColor" :bg-color="item.bgColor">
                        <span v-html="item.name"></span>
                    </RButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import RButton from '../Use/r-button'

    export default {
        name: "QuickReplies",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            },
            show: {
                type: Boolean,
                default: true
            },
            color:{
                type: String,
                default: ''
            },

        },
        data() {
            return {
                isClick:true, //防止快速重复点击
            };

        },
        methods: {
            onAsk(name,value,id){
                let that=this
                if(this.isClick){
                    this.isClick = false;
                    this.$emit('on-ask',name,value)
                    setTimeout(function() {
                        that.isClick = true;
                    }, 1000);
                }
            }
        }
    };
</script>
<style lang="less">
    .quickRepliesWrapper {
        /*position: absolute;*/
        /*left: .25rem;*/
        /*right: .25rem;*/
        /*bottom: 100%;*/
        overflow: hidden;

        /*padding: .1rem 0;*/
        transition: opacity .3s;

        ::-webkit-scrollbar {
            display: none;
            width:0;height:0;
        }
        .arrowTop{
            width: .45rem;
            height: .45rem;
            vertical-align: middle;
        }

    }

</style>
